import { useId } from "react";

const SportsBioIcon = ({ size = 32, className = "" }: { size?: number; className?: string }) => {
  const id = useId();
  const iconGradId = `iconGrad-${id}`;
  const accentGradId = `accentGrad-${id}`;

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 64 64"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <circle cx="32" cy="32" r="28" stroke={`url(#${iconGradId})`} strokeWidth="3" fill="none" opacity="0.3" />
      <circle cx="32" cy="32" r="20" stroke={`url(#${iconGradId})`} strokeWidth="2.5" fill="none" opacity="0.5" />
      <circle cx="32" cy="32" r="12" stroke={`url(#${iconGradId})`} strokeWidth="2" fill="none" opacity="0.7" />

      <line x1="32" y1="2" x2="32" y2="14" stroke={`url(#${iconGradId})`} strokeWidth="2" strokeLinecap="round" opacity="0.4" />
      <line x1="32" y1="50" x2="32" y2="62" stroke={`url(#${iconGradId})`} strokeWidth="2" strokeLinecap="round" opacity="0.4" />
      <line x1="2" y1="32" x2="14" y2="32" stroke={`url(#${iconGradId})`} strokeWidth="2" strokeLinecap="round" opacity="0.4" />
      <line x1="50" y1="32" x2="62" y2="32" stroke={`url(#${iconGradId})`} strokeWidth="2" strokeLinecap="round" opacity="0.4" />

      <circle cx="32" cy="32" r="5" fill={`url(#${iconGradId})`} />
      <circle cx="32" cy="32" r="3" fill="white" opacity="0.9" />

      <path
        d="M 22 22 Q 32 28, 42 22"
        stroke={`url(#${accentGradId})`}
        strokeWidth="2"
        fill="none"
        strokeLinecap="round"
        opacity="0.7"
      />
      <path
        d="M 22 42 Q 32 36, 42 42"
        stroke={`url(#${accentGradId})`}
        strokeWidth="2"
        fill="none"
        strokeLinecap="round"
        opacity="0.7"
      />

      <defs>
        <linearGradient id={iconGradId} x1="0" y1="0" x2="64" y2="64">
          <stop offset="0%" stopColor="hsl(245, 65%, 75%)" />
          <stop offset="100%" stopColor="hsl(252, 60%, 55%)" />
        </linearGradient>
        <linearGradient id={accentGradId} x1="0" y1="0" x2="64" y2="64">
          <stop offset="0%" stopColor="hsl(22, 52%, 60%)" />
          <stop offset="100%" stopColor="hsl(22, 52%, 45%)" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default SportsBioIcon;
